<div
  class="parent deposit-container"
  [contextMenuTrigger]="menu"
  [menuContext]="{ value: depositformsetting, visible: formVisible, service: order }"
  (menuAction)="($event)">
  <div>
    <date-picker
      name="ServingFoodDate"
      [group]="order.depositFormGroup"
      [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.DateOfServingFood' | translate"
      [required]="true"
      textType="date"
      [disabled]="false">
    </date-picker>
  </div>
  <div>
    <time-picker
      name="ServingFoodTime"
      [group]="order.depositFormGroup"
      [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.MealTime' | translate"
      [required]="true"
      textType="number"
      [disabled]="false"
      [showSeconds]="false">
    </time-picker>
  </div>
  <div>
    <ssg-select
      name="MealTime"
      [dataList]="MealTimeDataList"
      textFieldName="Title"
      valueFieldName="Id"
      [group]="order.depositFormGroup"
      [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.Meal' | translate"
      disabled="false"
      [required]="true"
      (valueChange)="setChangesOnInvoice()">
    </ssg-select>
  </div>
  <div *ngIf="order.HasClearType">
    <ssg-select
      name="ClearType"
      textFieldName="Title"
      valueFieldName="Id"
      [group]="order.depositFormGroup"
      [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.HowToSettle' | translate"
      [dataList]="ClearTypeDataList"
      [required]="order.HasClearType"
      (valueChange)="setChangesOnInvoice()">
    </ssg-select>
  </div>
  <div *ngIf="order.HasDeliveryType">
    <ssg-select
      name="DeliveryType"
      [dataList]="DeliveryTypeDataList"
      textFieldName="Title"
      valueFieldName="Id"
      [group]="order.depositFormGroup"
      [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.DeliveryType' | translate"
      [required]="order.HasDeliveryType"
      (valueChange)="onDeliveryTypeChanges($event); setChangesOnInvoice()">
    </ssg-select>
  </div>
  <div class="deposit-amount" *ngIf="order.HasDepositAmount">
    <ssg-input
      name="DepositAmount"
      [group]="order.depositFormGroup"
      [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.Deposit' | translate"
      required="false"
      disabled="true"
      textType="number"
      [withComma]="true"
      (valueChange)="setChangesOnInvoice()">
    </ssg-input>
  </div>
  <div *ngIf="order.HasNumberOfPeople">
    <ssg-input
      name="NumberOfPeople"
      [group]="order.depositFormGroup"
      [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.NumberOfPeople' | translate"
      required="false"
      disabled="false"
      textType="number"
      (valueChange)="setChangesOnInvoice()">
    </ssg-input>
  </div>

  <div *ngIf="order.HasNumberOfCooks">
    <ssg-input
      name="NumberOfCooks"
      [group]="order.depositFormGroup"
      [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.NumberOfCooks' | translate"
      required="{{ numberOfCooksIsRequired }}"
      disabled="false"
      textType="number"
      (valueChange)="setChangesOnInvoice()">
    </ssg-input>
  </div>
  <div *ngIf="order.HasServicesAmount">
    <ssg-input
      name="ServicesAmount"
      [group]="order.depositFormGroup"
      [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.ServiceAmount' | translate"
      required="false"
      disabled="false"
      textType="number"
      [withComma]="true"
      (valueChange)="setChangesOnInvoice()">
    </ssg-input>
  </div>
  <div *ngIf="order.FoodPricePerson">
    <ssg-input
      name="FoodPricePerson"
      [group]="order.depositFormGroup"
      [label]="'ClientApp.FrontOffice.Order.OrderPage.Item.Deposit.FoodPricePerPerson' | translate"
      required="false"
      disabled="true"
      textType="number"
      [withComma]="true">
    </ssg-input>
  </div>
</div>
<div class="deposit-grid">
  <ng-container class="content" *ngIf="order.HasServicesAmount">
    <editable-grid
      [columns]="columns"
      [dataList]="order.depositPersonnelList"
      [isAdd]="true"
      [isDelete]="true"
      [formTitle]="order.depositServiceAmountSummary"
      [formTitle2]="order.depositServiceRemainSummary"
      (afterSaved)="afterSavedList($event)"
      (afterDeleted)="afterDeletedList($event)"
      [height]="100"
      [noAutoFitColumns]="true">
    </editable-grid>
  </ng-container>
</div>
